import script from "./DeleteCompanyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteCompanyForm.vue?vue&type=script&setup=true&lang=js"

import "./DeleteCompanyForm.vue?vue&type=style&index=0&id=2be3ef3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be3ef3e"]])

export default __exports__